<template lang='pug'>
  blue-layout(:user='user' :account='account' :biz='biz')
    template(v-slot:default='props')
      bf-notice(@close='message = ""' :message='message')

      bf-dialog#rsv-dialog.positioned.no-header(
        :show='show.rsv'
        :scrolled='props.scrolled'
        @close='show.rsv = false'
      )
        add-order-dialog(
          :biz='biz'
          :account='account'
          :user='user'
          @notify='notify'
        )

      bf-wrapper#orders.view.content.no-header.smallest
        section#search(v-if='0==1')
          bf-input.icon-right.clear.thin
            input(type='search' :placeholder="$t('Search by date, name, service, etc...')")
            template(v-slot:icon)
              search-icon

        section#buttons
          bf-flex.centered
            bf-button.new-promo.tertiary.icon-only(@click.native='show.rsv = true')
              template(v-slot:icon)
                new-icon.icon2
                span.addorder {{$t("Add Order")}}
            bf-button.toggle-inactive.tertiary.link
              template(v-slot:text)
                router-link(:to='{ name: "orders" }') {{ $t('Next 7 Days') }}
            bf-button.toggle-active.clear
              template(v-slot:text) {{ $t('Week/Month') }}

        section#service-orders
          rsv-cal.vuecal--blue-theme.calendar.container(
            v-if='biz && biz.id'
            :biz='biz'
            :account='account'
            :user='user'
            :orders='reservations'
          )
</template>

<script>
  import { View } from '@/mixins/view'
  import { Orders } from '@/mixins/viewable'

  export default {
    name: 'orders-weekly.view',
    mixins: [View, Orders],

    methods: {
      filter(r) {
        return r.status != 'canceled'
      }
    }
  }
</script>

<style scoped lang='stylus'>
  .heading
    margin-bottom 32px

  #rsv-dialog
    background rgba(40 40 40 .8)
    padding 20px
    > .heading
      margin-bottom 20px
    .customers
      padding 1px
      overflow hidden
      .customer
        border-bottom 1px solid rgba( 0 0 0 .04 )
        border-top 1px solid rgba( 255 255 255 .5 )
        cursor pointer
        padding 12px 16px
        background rgba( 0 0 0 .04 )
        &.selected
          background rgba( 50 175 200 .75)
          color white
          border-bottom-color rgba( 0 0 0 .1 )
          border-top-color rgba( 255 255 255 1 )

        &:first-child
          border-top 0
          border-radius 12px 12px 0 0

        &:last-child
          border-radius 0 0 12px 12px

  #buttons
    margin 24px 0
    .bf-button
      margin-left 16px
      &:first-child
        margin-left 0
    .new-promo
      border 1px solid rgb(200 200 200)
    .toggle-inactive
      border 1px solid rgb(200 200 200)
      font-weight bold
      padding 3px 5px
    .toggle-active
      padding 10px 10px
    .icon2
      vertical-align middle
    .addorder
      font-size .48em
      veritcal-align middle
      font-weight bold
      margin-left 5px
  
  >>> .vuecal--week-view, >>> .vuecal--month-view, >>> .vuecal--day-view 
    border 2px solid grey
    border-radius 5px
    background rgb(250 250 250)
  >>> .vuecal__cell--today 
    background rgba(255 255 255 .9)
    font-weight bold
</style>
